import api from '@/api'
// eslint-disable-next-line
import axios from '@/axios'
import qs from 'qs';

const path = '/CIE10'

export default {
  getLista (obj) {
    console.log('getLista')
    return axios.get(`${api.url + path}/GetLista`,{
      params:obj
    })
  },

  get (obj) {
    var urlrequest = api.url + path;
    console.log('get ', urlrequest, obj);
    return axios.get(`${urlrequest}/Get`,{
      params:obj
    })
  },

  getFormData (id) {
    console.log('getFormData')
    return axios.get(`${api.url + path}/GetFormData`,{
      params: {
        'id': id,
        }
    })
  },
  //  Crea un nuevo detallediaslicencia
  crear (obj) {
    console.log('crear', obj)
    return axios.post(`${api.url + path}/Crear`, obj)
  },

  // Modifica DetalleDiasLicencia
  cambiar(obj){
    console.log('Cambiar', obj)
    return axios.post(`${api.url + path}/Cambiar`, obj)
  },

  // Modifica DetalleDiasLicencia
  eliminar(obj){
    console.log('eliminar', obj)
    return axios.post(`${api.url + path}/Eliminar`, obj)
  },
  find(obj){
    console.log('Find', obj)
    return axios.post(`${api.url + path}/Find`, obj)
  }
}



// WEBPACK FOOTER //
// ./src/services/cie10/index.js